/*
 * Copyright (C) 2026 to Present Applause App Quality, Inc. All rights reserved.
 */

import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

// Angular port of the AngularJS timeLeft filter: "in 6 months", or "in seconds" once a lock date has passed but
// the cycle hasn't been locked yet (`hidePrior`).
@Pipe({ name: 'utTimeLeft', standalone: true })
export class TimeLeftPipe implements PipeTransform {
  transform(date: number | string | Date, hidePrior = false): string {
    const now = new Date();
    moment.relativeTimeThreshold('m', 59);
    moment.relativeTimeThreshold('h', 48);
    if (hidePrior && moment(date).isBefore(now)) return 'in seconds';
    return moment(date).from(now);
  }
}
